import {compensateForScrollbar} from './general';

document.addEventListener('DOMContentLoaded', () => {
	const headerMenuContainer = document.querySelector('.header__navigation');
	const headerMenu = document.querySelector('.header__menu');
	const buttonMenu = document.querySelector('.header__button-menu');
	const menuItemSubmenu = document.querySelector('.menu__item--submenu > .menu__link');

	const screen = {
		width: window.innerWidth,
		height: window.innerHeight
	};

	const clickMenuItemSubmenuHandler = (evt) => {
    if (!headerMenu.classList.contains('menu-default')) return;

    evt.preventDefault();
		const menuItems = evt.target.parentElement.parentElement.children;

		evt.target.parentElement.classList.toggle('menu__item--submenu-show');

		for (let i = 0; i < menuItems.length; i++) {
			if (!menuItems[i].classList.contains('menu__item--submenu')) {
				menuItems[i].classList.toggle('menu__item--transparency');
			}
		}
	};

	const clickButtonMenuHandler = (evt) => {
		evt.preventDefault();
		buttonMenu.classList.toggle('icon-menu');
		buttonMenu.classList.toggle('icon-close');
		headerMenuContainer.classList.toggle('header__navigation--open-menu');
		headerMenu.classList.toggle('header__menu--show');

		if (buttonMenu.hasAttribute('data-compensate-scrollbar')) {
      document.documentElement.classList.toggle('page--fixed');
      // Устранение сдвига контентной области при разворачивании/сворачивании меню
      compensateForScrollbar();
    } else if (window.innerWidth < 1326) {
      document.documentElement.classList.toggle('page--fixed');
			compensateForScrollbar();
    }
	};

	const initButtonMenu = () => {
		buttonMenu.addEventListener('click', clickButtonMenuHandler);

		if (window.innerWidth < 1326) {
			menuItemSubmenu.addEventListener('click', clickMenuItemSubmenuHandler);
		}
	};

	const resetMenuState = () => {
		document.documentElement.classList.remove('page--fixed');
		buttonMenu.classList.add('icon-menu');
		buttonMenu.classList.remove('icon-close');
		headerMenuContainer.classList.remove('header__navigation--open-menu');
		headerMenu.classList.remove('header__menu--show');

		compensateForScrollbar(true);
	};

	const resizeHandler = () => {
		if (screen.width >= 1326 && window.innerWidth < 1326) {
			menuItemSubmenu.addEventListener('click', clickMenuItemSubmenuHandler);

			resetMenuState();
		}

		if (screen.width < 1326 && window.innerWidth >= 1326) {
			menuItemSubmenu.removeEventListener('click', clickMenuItemSubmenuHandler);

			resetMenuState();
		}

		screen.width = window.innerWidth;
		screen.height =  window.innerHeight;
	};

	initButtonMenu();
	window.addEventListener('resize', resizeHandler);
});
